import React from 'react'
import _ from 'underscore'
import TutorResultSubjectsPartial from './partial'

class TutorResultSubjects extends React.Component {

  render() {
    const tutor_subjects = this.props.matching ?
      this.props.tutor_result.matching_tutor_subjects
    :
      this.props.tutor_result.tutor_subjects

    return (
      <div>
        {_.map(tutor_subjects, function(tutor_subject) {
          return (
            <TutorResultSubjectsPartial key={tutor_subject.id} tutor_subject={tutor_subject}/>
          )
        })}
      </div>
    )
  }
}
export default TutorResultSubjects
